import { z } from "zod";

export const CountryDTOz = z
  .object({
    id: z.string(),
    country: z.string(),
    regions: z.array(z.string()),
  })
  .strict();

export type CountryDTO = z.infer<typeof CountryDTOz>;